export default {"src":"/_next/static/media/content_free_text.82fd971b.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};